/**
 * TagDetailPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Pagination,
  Statistic,
} from 'components';
import { Button, DatePicker, Input, Select, Tag } from 'antd';
import moment from 'moment';
import { stringToMoneyFormat } from 'utils';

const TagDetailPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedTag, setSelectedTag] = useState({});

  /* ===== VARIABLE ===== */
  let tags = [];
  for (let i = 0; i < 100; i++) {
    tags.push({
      id: i,
      tag: `태그 ${i + 1}`,
      created_at: new Date(),
      updated_at: new Date(),
      is_show: 'Y',
      product: 51331,
    });
  }

  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
    tag: {
      border: '1px solid #70737C',
      borderColor: 'rgba(112, 115, 124, 0.2)',
      background: 'transparent',
      color: 'var(--black-color)',
      fontWeight: 400,
      borderRadius: 4,
      padding: '2px 10px',
      display: 'inline-block',
      margin: '0px 4px 4px 0px',
      cursor: 'pointer',
    },
  };

  const formItem = [
    {
      label: '노출여부',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: '노출됨', value: '노출됨' },
                { label: '노출안됨', value: '노출안됨' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '등록일자',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '태그 명',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="태그 명을 입력해주세요"
                style={{ ...styles.form.input.large }}
              />
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  const state = ['판매중', '판매중지', '심사중', '반려'];
  for (let i = 0; i < 10; i++) {
    newData.push({
      상품번호: '000000',
      카테고리: '커피/원두',
      상품명: '[과테말라] 디카페인 200g',
      상태: state[Math.floor(Math.random() * 4)],
      판매가: 20000,
      할인가: 18000,
      수량: 57400,
      태그: ['고소한 맛', '베스트', '커피 원두'],
      판매처: 'JM커피',
    });
  }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>태그 상세정보</Title>

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 20 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ minWidth: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색된 태그 */}
          <Content
            maxWidth={'100%'}
            backgroundColor="none"
            padding={0}
            style={{ marginBottom: 20 }}
          >
            <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              검색된 태그 총<span>0</span>건
            </h4>
            <Content
              maxWidth={'100%'}
              borderRadius={4}
              padding={20}
              style={{
                border: '1px solid #70737C',
                borderColor: 'rgba(112, 115, 124, 0.2)',
                padding: '10px 15px',
                height: 74,
                overflow: 'auto',
              }}
            >
              {tags.map((_item, _index) => (
                <span
                  style={{
                    ...styles.tag,
                    borderColor:
                      selectedTag.id === _item.id
                        ? 'var(--primary-color)'
                        : 'rgba(112, 115, 124, 0.2)',
                    background:
                      selectedTag.id === _item.id
                        ? 'var(--primary-color)'
                        : 'transparent',
                    color:
                      selectedTag.id === _item.id
                        ? '#FFFFFF'
                        : 'var(--black-color)',
                    fontWeight: selectedTag.id === _item.id ? 600 : 400,
                  }}
                  onClick={() =>
                    setSelectedTag((prev) =>
                      prev.id === _item.id ? {} : { ..._item }
                    )
                  }
                >
                  #{_item.tag}
                </span>
              ))}
            </Content>
          </Content>
          {/* 검색된 태그 끝 */}

          {/* 요약 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 20, display: 'flex' }}
          >
            {[
              { title: '등록 된 상품', value: 777 },
              { title: '판매 중인 상품', value: 777 },
              { title: '총  판매 금액', value: 123444223 },
              { title: '총 판매량', value: 252235 },
            ].map((_item, _index) => (
              <div
                key={`${_item.label}-${_index}`}
                style={{
                  background: '#FFFFFF',
                  borderRadius: 4,
                  width: `calc(100% / 4)`,
                  marginRight: _index === 3 ? 0 : 4,
                  padding: 20,
                }}
              >
                <Statistic
                  title={_item.title}
                  value={stringToMoneyFormat(_item.value)}
                  suffix={_index === 2 ? '원' : '명'}
                  direction={'row'}
                  style={{ justifyContent: 'center' }}
                />
              </div>
            ))}
          </Content>
          {/* 요약 끝 */}

          {/* 선택된 태그 */}
          <Content maxWidth={'100%'} padding={0} style={{ marginBottom: 20 }}>
            <Table
              data={selectedTag.id ? [selectedTag] : []}
              minHeight={'auto'}
              columns={[
                {
                  title: '태그 번호',
                  key: 'id',
                },
                {
                  title: '태그 명',
                  key: 'tag',
                  render: (item) => (
                    <span style={{ ...styles.tag }}>#{item}</span>
                  ),
                },
                {
                  title: '등록일',
                  key: 'created_at',
                  render: (item) => moment(item).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                  title: '수정일',
                  key: 'updated_at',
                  render: (item) => moment(item).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                  title: '노출여부',
                  key: 'is_show',
                },
                {
                  title: '상품 수',
                  key: 'product',
                  render: (item) => stringToMoneyFormat(item),
                },
              ]}
            />
          </Content>
          {/* 선택된 태그 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
              검색 결과 총 <span>0</span>건
            </h4>
            <Table
              data={newData}
              columns={[
                {
                  title: '상품 번호',
                  key: '상품번호',
                },
                {
                  title: '카테고리',
                  key: '카테고리',
                },
                {
                  title: '상품명',
                  key: '상품명',
                  render: (item, { 상태 }) => (
                    <p>
                      <Tag
                        style={{
                          borderColor:
                            상태 === '판매중'
                              ? '#00BB2A'
                              : 상태 === '판매중지'
                              ? '#EE4700'
                              : 상태 === '심사중'
                              ? '#6541F2'
                              : '#F9A80C',
                          color:
                            상태 === '판매중'
                              ? '#00BB2A'
                              : 상태 === '판매중지'
                              ? '#EE4700'
                              : 상태 === '심사중'
                              ? '#6541F2'
                              : '#F9A80C',
                        }}
                      >
                        {상태}
                      </Tag>
                      {item}
                    </p>
                  ),
                },
                {
                  title: '판매가',
                  key: '판매가',
                  render: (item) => stringToMoneyFormat(item, '원'),
                },
                {
                  title: '할인가',
                  key: '할인가',
                  render: (item) => stringToMoneyFormat(item, '원'),
                },
                {
                  title: '수량',
                  key: '수량',
                  render: (item) => stringToMoneyFormat(item, '개'),
                },
                {
                  title: '등록된 다른 태그',
                  key: '태그',
                  render: (item) =>
                    item.map((i) => (
                      <span style={{ ...styles.tag }}>#{i}</span>
                    )),
                },
                {
                  title: '판매처',
                  key: '판매처',
                  render: (item) => (
                    <button
                      style={{
                        border: 'none',
                        background: 'none',
                        textDecoration: 'underline',
                        color: '#1C6BFF',
                        cursor: 'pointer',
                      }}
                    >
                      {item}
                    </button>
                  ),
                },
              ]}
            />
            <Pagination total={40} style={{ marginTop: 20 }} />
          </Content>

          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default TagDetailPresenter;
